import { render } from "./RegisterAnswer.vue?vue&type=template&id=48a13630&scoped=true"
import script from "./RegisterAnswer.vue?vue&type=script&lang=js"
export * from "./RegisterAnswer.vue?vue&type=script&lang=js"

import "./RegisterAnswer.vue?vue&type=style&index=0&id=48a13630&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a13630"]])

export default __exports__